// extracted by mini-css-extract-plugin
export default {"root":"YzrBeFcydK","pagerContainer":"txNNiiSuXy","pageInfoContainer":"cw8VeaKAEx"};